export default __webpack_public_path__ + "static/media/reason.216a49b1.png";